module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white-d1149c53c49b7f7f7f72ace1c492e405.png";